import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ArrowLeft } from 'react-bootstrap-icons';
import './AppBackButton.css';

interface AppBackButtonProps {
  /** Optional explicit destination. Falls back to history -1, or `/dashboard` */
  to?: string;
  label?: string;
  className?: string;
  /** When true, the button is wrapped in a thin top bar (use on full-bleed pages). */
  withWrapper?: boolean;
}

const AppBackButton: React.FC<AppBackButtonProps> = ({
  to,
  label = 'Back',
  className,
  withWrapper = false,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = () => {
    if (to) {
      navigate(to);
      return;
    }
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }
    navigate(location.pathname.startsWith('/dashboard') ? '/dashboard' : '/');
  };

  const button = (
    <button
      type="button"
      className={`app-back-btn${className ? ` ${className}` : ''}`}
      onClick={handleClick}
      aria-label={label}
    >
      <ArrowLeft size={16} aria-hidden />
      <span>{label}</span>
    </button>
  );

  if (!withWrapper) return button;

  return <div className="app-back-bar">{button}</div>;
};

export default AppBackButton;
